import React from "react";
import PropTypes from "prop-types";

const ClubFormatter = ({ row }) => <div>{row.clubId ? row.club : row.clubString}</div>;

ClubFormatter.propTypes = {
  row: PropTypes.object
};

export default ClubFormatter;
